export default __webpack_public_path__ + "static/media/gb.aa013322.svg";